import { useEffect } from 'react'

const NotFound = () => {
  // Bei inkorrektem Link not found (404), redirect auf Root
  useEffect(() => {
    window.location.href = window.location.origin
  }, [])
  return <></>
}

export default NotFound
